<template>
  <router-view :key="routerViewKey" ></router-view>
</template>

<script setup lang="ts">
import {computed} from "vue";
import { useRoute } from 'vue-router';
import {useMessage, useNotification, useDialog, useModal,useLoadingBar} from "naive-ui";

const route = useRoute();

const routerViewKey = computed(() => {
  const projectId = route.params.projectId;
  return typeof projectId === 'string' ? projectId : '';
});

//反馈组件注册至全局
window.$message = useMessage();
window.$dialog = useDialog();
window.$modal = useModal();
window.$loadingBar = useLoadingBar();
window.$notification = useNotification();
</script>

<style scoped lang="less">

</style>